export default {
  setChecklist(state, checklist) {
    state.checklist = checklist;
  }
};
